/* eslint-disable */
export const HTTP_SERVICE_REQUEST_OBSERVE_BODY = `body`;
export const HTTP_SERVICE_REQUEST_OBSERVE_EVENTS = `events`;
export const HTTP_SERVICE_REQUEST_OBSERVE_RESPONSE = `response`;
